import { render, staticRenderFns } from "./lookWrong.vue?vue&type=template&id=94dce96e&scoped=true"
import script from "./lookWrong.vue?vue&type=script&lang=js"
export * from "./lookWrong.vue?vue&type=script&lang=js"
import style0 from "./lookWrong.vue?vue&type=style&index=0&id=94dce96e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94dce96e",
  null
  
)

export default component.exports